import { createAction } from "redux-starter-kit";

const actions = {
  lockCoach: {
    request: createAction("admin/lockCoach/request"),
    success: createAction("admin/lockCoach/success"),
    failure: createAction("admin/lockCoach/failure"),
  },
  unlockCoach: {
    request: createAction("admin/unlockCoach/request"),
    success: createAction("admin/unlockCoach/success"),
    failure: createAction("admin/unlockCoach/failure"),
  },
  moveCoachMembers: {
    request: createAction("admin/moveCoachMembers/request"),
    success: createAction("admin/moveCoachMembers/success"),
    failure: createAction("admin/moveCoachMembers/failure"),
  },
};

export default actions;
